"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appleAuthSpiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function appleAuthSpiClient(networkClient) {
    return {
        getOrganisationBearerToken: async (orgId) => {
            return networkClient.getHttp(data_lib_1.APPLE_AUTH_WEB_SERVICE, `/spi/v2/apple-auth/organisations/${orgId}/bearer`);
        },
        getActiveOrganisationIds: async () => {
            return networkClient.getHttp(data_lib_1.APPLE_AUTH_WEB_SERVICE, `/spi/v2/apple-auth/activeIds`);
        },
        /**
         * This call will resolve before the refresh is completed.
         */
        refreshActiveIds: async () => {
            return networkClient.postHttp(data_lib_1.APPLE_AUTH_WEB_SERVICE, `/spi/v2/apple-auth/activeIds/refresh`, {});
        },
        /**
         * This naming seems confusing being prefixed 'sync' and being a promise.
         * This is because if you await this resolving then the refresh will be complete.
         * In contrast to the non-sync version which will resolve quickly without the refresh being completed.
         */
        syncRefreshActiveIds: async () => {
            return networkClient.postHttp(data_lib_1.APPLE_AUTH_WEB_SERVICE, `/spi/v2/apple-auth/activeIds/refreshSync`, {});
        },
    };
}
exports.appleAuthSpiClient = appleAuthSpiClient;
